import TRADEFACIL_EXT_1 from "./TRADEFACIL_EXT_1";
export default {
  TRADEFACIL_EXT_1,
};
